module.exports = __webpack_public_path__ + "img/dark-main-demo.4fa30269.png";